import { render, staticRenderFns } from "./AlterarDadosPessoais.vue?vue&type=template&id=bf8a29ce&scoped=true&"
import script from "./AlterarDadosPessoais.vue?vue&type=script&lang=js&"
export * from "./AlterarDadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./AlterarDadosPessoais.vue?vue&type=style&index=0&id=bf8a29ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8a29ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VDialog,VForm,VTextField})
